<template>
	<div class="page">
		<div class="menu">
			<el-menu :default-active="menuName" @select="selectMenu">
				<el-menu-item :index="item.name" v-for="(item,index) in menuList" :key="index"
					:class="menuName == item.name ? 'menu_on' : ''">
					<span slot="title">{{ item.name }}</span>
				</el-menu-item>
			</el-menu>
		</div>
		
		<div class="decor">
			<home v-show="menuName == 'PC首页'" class="phone-content"></home>
		</div>
	</div>
</template>

<script>
	import home from '../component/pc/home.vue';
	export default {
		components: {
			home
		},
		data() {
			return {
				menuName: 'PC首页',
				menuList: [{name: 'PC首页'}],
			};
		},
		methods: {
			selectMenu(e) {
				this.menuName = e;
			},
		}
	};
</script>

<style lang="scss" scoped>
	.page {
		background-color: #fff;
		width: 100%;
		max-height: 100vh;
		display: flex;
		overflow: hidden;
		padding: 20px;
		box-sizing: border-box;
		
		.menu {
			width: 140px;
			min-width: 140px;
			flex-shrink: 0;
			overflow-y: auto;

			.menu_on {
				border-right: 2px solid #3E84E9;
			}
		}
		
		.decor {
			flex: 1;
			min-width: 0;
			overflow: hidden;
			margin-left: 20px;
		}
		
		.btn {
			position: fixed;
			bottom: 30px;
			width: 100%;
			display: flex;
			justify-content: center;
		}
		
		/* 响应式适配 */
		@media (max-width: 1366px) {
			padding: 15px;
			.menu {
				width: 120px;
				min-width: 120px;
			}
			.decor {
				margin-left: 15px;
			}
		}
		
		@media (max-width: 1024px) {
			padding: 10px;
			.menu {
				width: 100px;
				min-width: 100px;
			}
			.decor {
				margin-left: 10px;
			}
		}
	}
</style>